import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function MaritalStautus() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [maritalStatusList, setMaritalStatusList] = useState([]);

  useEffect(() => {
    CommonService.getAllMaritalStatus().then((data) =>
      setMaritalStatusList(data)
    );
  }, []);

  return (
    <fieldset>
      <legend>{t("Marital Status")}</legend>
      <select
        name="maritalStatusId"
        value={searchObject.maritalStatusId || ""}
        onChange={onChange}
        className="form-select"
      >
        <option key={0} value="" selected>
        </option>
        {maritalStatusList.map((maritalStatus) => (
          <option value={maritalStatus.id} key={maritalStatus.id}>
            {t(maritalStatus.description)}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
